
import GetSettings from './GetSettings';
import GetLanguage from './GetLanguage';
import GetFilters from './GetFilters';
import GetOpeningHours from './GetOpeningHours';
import UserLogin from './UserLogin';
import GetCategories from './GetCategories';
import GetBaseCategories from "./GetBaseCategories";
import GetProductList from './GetProductList';
import GetCountryList from './GetCountryList';
import UserRegister from './UserRegister';
import GetProduct from './GetProduct';
import GetAdditionalCharges from './GetAdditionalCharges';
import GetValidateCart from './GetValidateCart';
import GetCartOffers from './GetCartOffers';
import UserProfile from './UserProfile';
import GetCityList from './GetCityList';
import GetShippingPrimaryPrice from './GetShippingPrimaryPrice';
import GetShippingSecondaryPrice from './GetShippingSecondaryPrice';
import CalculateOpeningHours from './CalculateOpeningHours';
import GetLoyaltyPoints from './GetLoyaltyPoints';
import SaveOrderInfo from './SaveOrderInfo';
import GetOrderInfo from './GetOrderInfo';
import GetUserData from './GetUserData';
import GetCartProducts from './GetCartProducts';
import UpdateCart from './UpdateCart';
import CalculateLoyaltyPoints from './CalculateLoyaltyPoints';
import SubmitOrder from './SubmitOrder';
import ChangeLocation from './ChangeLocation';
import GetCurrentLocation from './GetCurrentLocation';
import ProceedToPayment from './ProceedToPayment';
import UserProfileEdit from './UserProfileEdit';
import UserChangePassword from './UserChangePassword';
import UserChangeProfileImage from './UserChangeProfileImage';
import UserLogout from './UserLogout';
import GetOrderHistory from './GetOrderHistory';
import GetCheckoutStatus from './GetCheckoutStatus';
import UpdateCheckoutStatus from './UpdateCheckoutStatus';
import ValidateDiscountCode from './ValidateDiscountCode';
import GetDiscountCode from './GetDiscountCode';
import UpdateDiscountCode from './UpdateDiscountCode';
import UserForgotPassword from './UserForgotPassword';
import UserResetPassword from './UserResetPassword';
import GetPaymentMethods from "./GetPaymentMethods";
import GetSpecificProducts from './GetSpecificProductList';
import GetBestSellingProducts from "./GetBestSellingProductList";
import GetOfferProducts from "./GetOfferProductList";
import GetAddresses from "./GetAddresses";
import SaveAddress from "./SaveAddress";
import GetAddress from "./GetAddress";
import EditAddress from "./EditAddress";
import DeleteAddress from "./DeleteAddress";
import SetDefaultAddress from "./SetDefaultAddress";
import getFacertData from "./getFacertData";
import getFilterProduct from "./getFilterProduct";
import GetQuantityBasePriceModule from "./GetQuantityBasePriceModule";
import GetAbandonedCart from "./GetAbandonedCart";
import StoreCart from "./StoreCart";
import GetCategroy from "./GetCategroy";
import UserRegisterFn from "./UserRegisterFn";
import GetCategroyByProduct from "./GetCategroyByProduct";
import GetCategroyByCode from "./GetCategroyByCode";
import GetTemplateList from "./GetTemplateList";
import GetSocialProviders from "./GetSocialProviders";
import SetSocialAuth from "./SetSocialAuth";
import GetCmsPageContent from './GetCmsPageContent';
import VerifyOtp from './VerifyOtp';



export default {
  GetSettings,
  GetLanguage,
  GetFilters,
  GetOpeningHours,
  UserLogin,
  GetCategories,
  GetBaseCategories,
  GetProductList,
  GetCountryList,
  UserRegister,
  GetProduct,
  GetAdditionalCharges,
  GetValidateCart,
  GetCartOffers,
  UserProfile,
  GetCityList,
  GetShippingPrimaryPrice,
  GetShippingSecondaryPrice,
  CalculateOpeningHours,
  GetLoyaltyPoints,
  SaveOrderInfo,
  GetOrderInfo,
  GetUserData,
  GetCartProducts,
  UpdateCart,
  CalculateLoyaltyPoints,
  SubmitOrder,
  ChangeLocation,
  GetCurrentLocation,
  ProceedToPayment,
  UserProfileEdit,
  UserChangePassword,
  UserChangeProfileImage,
  UserLogout,
  GetOrderHistory,
  GetCheckoutStatus,
  UpdateCheckoutStatus,
  ValidateDiscountCode,
  GetDiscountCode,
  UpdateDiscountCode,
  UserForgotPassword,
  UserResetPassword,
  GetPaymentMethods,
  GetSpecificProducts,
  GetBestSellingProducts,
  GetOfferProducts,
  GetAddresses,
  GetAddress,
  EditAddress,
  SaveAddress,
  DeleteAddress,
  SetDefaultAddress,
  getFacertData,
  getFilterProduct,
  GetQuantityBasePriceModule,
  GetAbandonedCart,
  StoreCart,
  GetCategroy,
  UserRegisterFn,
  GetCategroyByProduct,
  GetCategroyByCode,
  GetTemplateList,
  GetSocialProviders,
  SetSocialAuth,
  GetCmsPageContent,
  VerifyOtp

};